module.exports = __webpack_public_path__ + "static/media/toll.c016bed8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/journey/toll.png
// module id = 315
// module chunks = 0